import { reactive } from 'vue'

export type ToastVariant = 'success' | 'info' | 'warning' | 'error'

export interface ToastItem {
  id: number
  message: string
  variant: ToastVariant
}

const state = reactive({
  items: [] as ToastItem[],
})

let seq = 0

function push(message: string, variant: ToastVariant) {
  const text = message.trim()
  if (!text) return
  const id = ++seq
  state.items.push({ id, message: text, variant })
  window.setTimeout(() => {
    state.items = state.items.filter((item) => item.id !== id)
  }, 3200)
}

export const toast = {
  get items() {
    return state.items
  },
  success(message: string) {
    push(message, 'success')
  },
  info(message: string) {
    push(message, 'info')
  },
  warning(message: string) {
    push(message, 'warning')
  },
  error(message: string) {
    push(message, 'error')
  },
}
